import styled from 'styled-components';
import tw, { classnames, position, padding, minHeight, display, flexDirection, backgroundColor, borderColor, borderRadius } from 'tailwindcss-classnames';

export const AnswersContainer = styled.div.attrs({
    className: classnames(position('relative'), padding('px-0', 'pb-8', 'pt-12'), minHeight('min-h-full'))
})``;

export const AnswersHeader = styled.div.attrs({
    className: classnames(position('relative'), display('flex'), flexDirection('flex-col'), padding('px-0', 'py-2', 'px-6'), backgroundColor('bg-gray-50'), borderColor('border-gray-100'), borderRadius('rounded-md'))
})`
border-bottom: 1px solid;
`;